<template>
  <div class="col-md-8">
    <div class="form-group">
      <div my-15px>
        <label class="mx-5">
          <h5>
            Prize Details Frame
            <span class="small light"> (recommended size 837 x 1190)</span>
          </h5>
        </label>

        <div class="form-group">
          <div class="d-block">
            <img
              class="img img-fluid image-preview"
              v-if="picture"
              :src="picture"
            />
          </div>
          <input
            type="file"
            accept="image/*"
            class="form-control"
            @change="uploadImage"
            ref="prize_details_frame_picture"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { luckyDrawService } from "@/api/client";

export default {
  props: ["campaign"],

  data() {
    return {
      file: null,
    };
  },
  computed: {
    picture() {
      return this.campaign.prize_details_frame_picture;
    },

    disabled() {
      return this.campaign.status != "draft";
    },
  },
  methods: {
    async uploadImage(event) {
      const file = event.target.files[0];

      if (file.size > 1000000) {
        this.$notify("File shall not exceed 1 MB");
        event.target.files[0].value = "";
        return;
      }

      try {
        if (!file) return;
        const form = new FormData();

        const { id } = this.campaign;

        form.append("id", id);
        form.append("image", file);
        form.append("field", "prize_details_frame_picture");

        await luckyDrawService.fileUpload(form);

        this.$emit("updated");
        this.$notify(`Prize details frame updated.`);
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Prize details frame error.`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.light {
  color: gray;
  font-weight: 300;
}

.image-preview {
  padding: 12px;
  min-height: 200px;
  background-color: #eaeaea;
}

.image-preview,
input[type="file"] {
  max-width: 420px;
}
</style>
